import React from 'react';
import { Dialog, DialogContent, DialogTitle, makeStyles, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import Table from '../../components/Table/Table';

const useStyles = makeStyles((theme) => ({
  chartDialogTitle: {
    '& > .MuiTypography-root': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& svg': {
      cursor: 'pointer',
    },
  },
}));

const PaperStatistics = (props) => {
  const { count, countCountry, openChart, handleClose } = props;
  const classes = useStyles();

  return (
    <Dialog open={openChart} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="customized-dialog-title" className={classes.chartDialogTitle}>
        Free Paper 통계
        <CloseIcon onClick={handleClose} />
      </DialogTitle>
      <DialogContent dividers>
        <h3>Presentation Type</h3>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                Oral
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['oral']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>E-Poster</TableCell>
              <TableCell>{count['eposter']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <h3>Abstract Topic</h3>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                Basic Research
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['basic']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Craniofacial / Trauma</TableCell>
              <TableCell>{count['craniofacial']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Hand & Upper Limb Reconstruction</TableCell>
              <TableCell>{count['handnupper']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Head and Neck Reconstruction</TableCell>
              <TableCell>{count['headnneck']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Breast / Body Reconstruction</TableCell>
              <TableCell>{count['breast']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Lower Limb Reconstruction</TableCell>
              <TableCell>{count['lowerlimb']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Lymphedema</TableCell>
              <TableCell>{count['lymphedema']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Eyelid and Periocular Surgery</TableCell>
              <TableCell>{count['eyelid']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Rhinoplasty</TableCell>
              <TableCell>{count['rhinoplasty']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Anti-aging Surgery</TableCell>
              <TableCell>{count['antiaging']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Facial Contouring Surgery</TableCell>
              <TableCell>{count['facial']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Aesthetic Breast Surgery</TableCell>
              <TableCell>{count['aesthetic']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Body Contouring Surgery</TableCell>
              <TableCell>{count['bodycontouring']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Botox, Filler, Minimally Invasive Surgery</TableCell>
              <TableCell>{count['botox']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Laser</TableCell>
              <TableCell>{count['laser']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Fat and Stem Cell Therapy</TableCell>
              <TableCell>{count['fatnstem']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Hair</TableCell>
              <TableCell>{count['hair']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>Other Plastic Surgery</TableCell>
              <TableCell>{count['other']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <h3>국가별</h3>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>국가명</TableCell>
              <TableCell>인원</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {countCountry.map(
              (item) =>
                item.count > 0 && (
                  <TableRow key={item.name}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell align="center">{item.count}</TableCell>
                  </TableRow>
                ),
            )}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default PaperStatistics;
